import { Check } from './icons';
import JourneyTimeline from './JourneyTimeline';
import styles from './About.module.css';

const HIGHLIGHTS = [
  'You work directly with me — never a hand-off',
  'Since 2007 — from NetSuite end-user to expert',
  'Practical, transparent AI — enablement & audits',
  'Developer mentoring & team enablement',
];

export default function About() {
  return (
    <section className="section" id="about">
      <div className="wrap">
        <div className={styles.aboutGrid}>
          <div className="reveal">
            <span className="eyebrow">About</span>
            <h2 className="section-title" style={{ marginTop: 16 }}>
              From the warehouse floor
              <br />
              to independent NetSuite expert.
            </h2>
            <p className={styles.aboutLead}>
              I'm Jordan Patterson — and JP Custom Works is me: an independent NetSuite consultant and
              full-stack developer. My NetSuite story didn't start in consulting; it started on the
              warehouse floor as a shipping/receiving clerk, using NetSuite every day as the end user.
              In the years since, I've worked nearly every angle of the platform — power user,
              administrator, developer, architect, and now independent expert.
            </p>
            <p className={styles.aboutBody}>
              That path is the difference. I've been the person living in NetSuite to get the job done,
              so I build for how work actually happens — not how a slide deck says it should. Hire me
              and you get all of that directly: I scope it, I build it, and I stand behind it. No
              juniors, no hand-offs, no telephone game.
            </p>
            <p className={styles.aboutBody}>
              I also love to teach. Alongside delivery, I mentor in-house NetSuite and development teams
              — code reviews, SuiteScript best practices, and hands-on enablement that leaves your people
              more capable than when I arrived.
            </p>
            <a href="#contact" className="btn btn-primary" style={{ marginTop: 24 }}>
              Start a Conversation
            </a>
          </div>

          <aside className={`${styles.aboutCard} reveal`}>
            <div className={styles.aboutPerson}>
              <span className={styles.aboutAvatar}>JP</span>
              <div>
                <b>Jordan Patterson</b>
                <span>Independent NetSuite Consultant &amp; Developer</span>
              </div>
            </div>
            <ul className={styles.aboutList}>
              {HIGHLIGHTS.map((text) => (
                <li key={text}>
                  <Check />
                  {text}
                </li>
              ))}
            </ul>
          </aside>
        </div>

        <JourneyTimeline />
      </div>
    </section>
  );
}
